module.exports = __webpack_public_path__ + "img/cursive-workbook_B0991GDVL7.9f6aef51.jpg";